import Vue from 'vue'
import { getApp } from 'firebase/app'
import { getFunctions, httpsCallable } from 'firebase/functions'

export default Vue.extend({
  name: 'SignaturesMixin',
  data() {
    return {
      secretKey: process.env.JWT_KEY as any,
      region: process.env.REGION || 'us-central1',
    }
  },
  methods: {
    async generateJwtToken(payload: any) {
      const functions = getFunctions(getApp(), this.region)
      const signJWTFunction = httpsCallable(functions, 'signatures-signJWT')
      const token = await signJWTFunction({
        payload,
      })
      return token.data
    },
    async generateJwtTokenCustom(payload: any) {
      const functions = getFunctions(getApp(), this.region)
      const cipherFunction = httpsCallable(functions, 'signatures-cipher')
      const token = await cipherFunction({
        payload,
      })
      return token
    },
  },
})
